import * as React from 'react';
import { useField } from 'react-final-form';
import { InputTextWithAddon, InputText } from '@gandi/form';
import { FinalFormGroup } from '@gandi/form/FinalForm';
import { useTranslator } from '@gandi/translate';
import { jsx as _jsx } from "react/jsx-runtime";
const InputMailbox = ({
  readOnly,
  name,
  ...props
}) => {
  const {
    __
  } = useTranslator();
  const {
    input
  } = useField(name);
  if (readOnly) {
    return /*#__PURE__*/_jsx(InputText, {
      ...input,
      ...props,
      readOnly: true
    });
  }
  return /*#__PURE__*/_jsx(InputTextWithAddon, {
    ...input,
    ...props,
    placeholder: __('Contact'),
    rightAddon: "@example.com"
  });
};
const InputMailboxFieldGroup = ({
  label,
  ...props
}) => {
  const {
    __
  } = useTranslator();
  const {
    input: {
      value
    }
    // $FlowFixMe[prop-missing]
  } = useField(props.name, {
    subscription: {
      value: true
    }
  });
  const help = value.length === 0 ? __('e.g. contact@example.com') : __('%(login)s@example.com', {
    login: value
  });
  return /*#__PURE__*/_jsx(FinalFormGroup, {
    name: props.name,
    label: label,
    help: help,
    required: props.required,
    children: /*#__PURE__*/_jsx(InputMailbox, {
      id: props.name,
      ...props
    })
  });
};
export default InputMailboxFieldGroup;